import { render } from "./zaku-pos-uploader.vue?vue&type=template&id=6effd684&scoped=true"
import script from "./zaku-pos-uploader.vue?vue&type=script&lang=js"
export * from "./zaku-pos-uploader.vue?vue&type=script&lang=js"

import "./zaku-pos-uploader.vue?vue&type=style&index=0&id=6effd684&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6effd684"]])

export default __exports__